(function () {
	'use strict';
	var controllerId = 'elencoRichieste';
	angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'datacontext', '_', 'common', '$uibModalInstance', 'richieste', '$translate', elencoRichiesteFn]);

	function elencoRichiesteFn($scope, $rootScope, datacontext, _, common, $uibModalInstance, richieste, $translate) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, "logError");
		var logSuccess = getLogFn(controllerId, "logSuccess");		
		$scope.list = {};
		$scope.item = {};
		$scope.item.view = 'list';
        
		$scope.list.richieste = [];
		richieste.forEach(function (o) {		    
		    if (o.DestId == $rootScope.id) {
		        o.DocenteId = o.MittId;
		        o.Nome = o.Mitt;
		        o.Citta = o.MittCitta;
		        o.Istituto = o.MittIstituto;
		        o.Materia = o.MittMateria;
		        o.stat_numTest = o.MittTest;
		        o.Sesso = o.MittSesso;
		        o.Icona = o.MittIcona;
		        o.Ricevuta = true;
		    }
		    else if (o.MittId == $rootScope.id) {
		        o.DocenteId = o.DestId;
		        o.Nome = o.Dest;
		        o.Citta = o.DestCitta;
		        o.Istituto = o.DestIstituto;
		        o.Materia = o.DestMateria;
		        o.stat_numTest = o.DestTest;
		        o.Sesso = o.DestSesso;
		        o.Icona = o.DestIcona;
		        o.Ricevuta = false;
		    }

		    $scope.list.richieste.push(o);
		});

		$scope.back = function () {
		    $scope.docente = {};
		    $scope.item.view = 'list';		    
		}

		$scope.detail = function (o) {
		    $scope.docente = o;		    
		    datacontext.materia_getAllByDocenteId($scope.docente.DocenteId).then(function (materie) {
		        datacontext.classe_getAllByDocenteId($scope.docente.DocenteId).then(function (classi) {		            
		            $scope.docente.classi = _.uniq(classi, 'Grado');
		        });
		        $scope.docente.materie = materie;
		    });
		    $scope.item.view = 'detail';
		}

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};

		$scope.annullaRichiesta = function () {
		    datacontext.community_deleteAmicizia($scope.docente.Id).then(function (data) {
		        if (data == '200') {
		            logSuccess($translate.instant('RichiestaAnnullata'));
		            $scope.docente = {};
		            $uibModalInstance.close();
		        }
		        else
		            logError($translate.instant('ErroreElaborazioneRichiesta'));
		    });
		}

		$scope.accettaAmicizia = function () {
		    datacontext.community_accettaAmicizia($scope.docente.Id).then(function (data) {
		        if (data && data.Id) {
		            logSuccess($translate.instant('AmiciziaAccettata'));
		            $scope.docente = {};
		            $uibModalInstance.close();

		            $rootScope.richiesteCount = 0;
		            datacontext.community_getAllRichieste(0).then(function (data) {
		                $rootScope.richiesteCount = data.length;
		            });
		        }
		        else
		            logError($translate.instant('ErroreElaborazioneRichiesta'));
		    });
		}

		$scope.rifiutaAmicizia = function () {
		    datacontext.community_rifiutaAmicizia($scope.docente.Id).then(function (data) {
		        if (data && data.Id) {
		            logSuccess($translate.instant('AmiciziaRifiutata'));
		            $scope.docente = {};
		            $uibModalInstance.close();

		            $rootScope.richiesteCount = 0;
		            datacontext.community_getAllRichieste(0).then(function (data) {
		                $rootScope.richiesteCount = data.length;
		            });
		        }
		        else
		            logError($translate.instant('ErroreElaborazioneRichiesta'));
		    });
		}

		$scope.cancellaAmicizia = function () {
		    datacontext.community_deleteAmicizia($scope.docente.Id).then(function (data) {
		        if (data == '200') {
		            logSuccess($translate.instant('AmiciziaCancellata'));
		            $uibModalInstance.close();
		        }
		        else
		            logError($translate.instant('ErroreElaborazioneRichiesta'));
		    });
		}
	}
})();